import React from "react"
import Network from "../base-pages/network"

const NetworkEN = () => {
  return <Network lang="en" />
}

export default NetworkEN
